import styled from "@emotion/styled";

export const Wrapper = styled("div")(({ theme }) => ({
  label: "home-wrapper",

  width: "100%",
  marginTop: "-64px",
}));
